export default function Bubble({ isLeft, children }) {
  return (
    <div
      className={`py-1 px-3 rounded-xl relative max-w-[75%] w-fit text-xs ${
        isLeft
          ? 'bg-yellow-50 ml-4 text-black mr-auto shadow-lg shadow-gray-400/50'
          : 'bg-blue-500 mr-4 text-white ml-auto shadow-lg shadow-blue-500/50'
      }`}
    >
      <div dangerouslySetInnerHTML={{ __html: children }} />
      <div
        className={`${
          isLeft
            ? 'absolute bottom-1 -left-[6px] border-t-[6px] border-t-transparent border-r-[10px] border-r-yellow-50 border-b-[10px] border-b-transparent'
            : 'absolute bottom-1 -right-[6px] border-t-[6px] border-t-transparent border-l-[10px] border-l-blue-500 border-b-[10px] border-b-transparent'
        }`}
      />
    </div>
  )
}
